import { DefinedEnvelopesTable } from "@/components/partial";

function AdminDocumentDefinedEnvelopes() {
  return <DefinedEnvelopesTable />;
}

export default AdminDocumentDefinedEnvelopes;
